export const ReportManagerEndpoint = {
  LOAD_AVAILABLE_CHARTS: '/default/report-manager/load-available-charts',
  LOAD_DEFAULT_PREVIEW: '/default/report-manager/load-default-preview',
  LOAD_PREVIEW: '/default/report-manager/load-preview',
  LOAD_REPORT: '/default/report-manager/load-report',
  SAVE_REPORT: '/default/report-manager/save-report',
  DELETE_REPORT: '/default/report-manager/delete-report',
  LOAD_REPORTS: '/default/report-manager/load-reports',
  LOAD_REPORT_TRANSMISSION: '/default/report-manager/load-report-transmission',
  RUN_REPORT: '/default/report-manager/run-report',
  UPDATE_REPORT_TRANSMISSION: '/default/report-manager/update-report-transmission',
};
